import WrapperService from '@/modules/core/services/wrapper-service';

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/option';

const serviceName = "Option-Service: ";

export default class OptionService {

    static async readOptions(successF, errorF) {
        await WrapperService.get(API_URL + '/list', null, serviceName, successF, errorF);
    }

    static async getSnapshotCount(elevatorId, successF, errorF) {
        await WrapperService.post(
          API_URL + `/value/elevator/${elevatorId}`,
          {key: 'SNAP ELEVATOR IMAGE COUNTER'},
          serviceName,
          successF,
          errorF
        );
    }
}